export default __webpack_public_path__ + "5495de6f4b7d27ccfe1a2dc0e2327229.png";